<ng-template #modal let-modal class="modal-dialog-centered">
    <div class="modal-header">
        <h4 class="modal-title text-center w-100" id="modalLabel">
            {{ modalTitle | translate }}
        </h4>
        <button type="button" class="btn-close" tabindex="-1" aria-label="Close" (click)="closeModal()">
        </button>
    </div>
    <div class="modal-body p-1">
        <div *ngIf="loading" class="row" style="height: 30px">
            <app-ui-preloader id="spinner" [display]="loading" [size]="'20px'"></app-ui-preloader>
        </div>

        <!-- <div *ngIf="!loading" id="tab" class="col-md-12">
            <ul ngbNav #tab="ngbNav" [(activeId)]="tabsBug" class="nav-tabs nav-bordered">
                <ng-container *ngFor="let language of languages; let i = index">
                    <li [ngbNavItem]="i+1">
                        <a ngbNavLink>
                            {{language.description}}
                        </a>

                        <ng-template ngbNavContent>
                            <ng-container *ngTemplateOutlet="language.locale=='pt'?Tab1:Tab2">
                            </ng-container>
                        </ng-template>
                    </li>
                </ng-container>

            </ul>

            <div [ngbNavOutlet]="tab"></div>
        </div> -->
        <ng-container *ngTemplateOutlet="Tab1">
        </ng-container>

        <ng-template #Tab1>
            <form [formGroup]="bugForm" class="p-2 mt-n2 form">
                <div class="row">
                    <div class="col-md-12">
                        <div class="mb-2">
                            <label class="form-label">{{ labelInput | translate }}</label>
                            <input type="text" class="form-control" formControlName="En"
                                [ngClass]="{'is-invalid':submitted && formBug.En.invalid}" required>
                            <div *ngIf="submitted && formBug.En.invalid" class="invalid-feedback">
                                <div *ngIf="formBug.En.errors?.required">{{ errorInput | translate }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </ng-template>

        <!-- <ng-template #Tab2>
            <form [formGroup]="bugForm" class="p-2 mt-n2 form">
                <div class="row">
                    <div class="col-md-12">
                        <div class="mb-2">
                            <label class="form-label">{{ labelInput | translate }}</label>
                            <input type="text" class="form-control" formControlName="En"
                                [ngClass]="{'is-invalid':submitted && formBug.En.invalid}" required>
                            <div *ngIf="submitted && formBug.En.invalid" class="invalid-feedback">
                                <div *ngIf="formBug.En.errors?.required">{{ errorInput | translate }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </ng-template> -->

    </div>
    <div class="mt-2 mb-2 d-flex justify-content-center">

        <button class="btn btn-primary waves-effect waves-light btnSaveBottom btnSaveMinW2" [disabled]="loading" (click)="save()">
            {{modalTitle|translate}}
        </button>
    </div>
</ng-template>